Vendd.Scripts.load(function () {

    var Vendd = window.Vendd || {};

    var dynamicAction = function (element, definition) {

        Vendd.inlineEdit.action.apply(this, [element, definition]);

    };
    dynamicAction.prototype = Object.create(Vendd.inlineEdit.action.prototype);
    dynamicAction.prototype.name = 'dynamicAction';

    dynamicAction.prototype.Enabled = function () {

        var self = this;

        var form = self.getForm();

        return form !== undefined
            && typeof self.definition.execute === 'function'
            && (self.definition.hasChanges === undefined || (typeof self.definition.hasChanges === 'function' && self.definition.hasChanges(self)));
    }

    dynamicAction.prototype.execute = function () {

        var self = this;

        if (!self.Enabled()) {

            return;

        }

        var form = self.getForm();

        if (form === undefined) {

            return;

        }

        if (typeof self.definition.execute !== 'function') {

            return;

        }

        self.definition.execute(self);

    };

    Vendd.inlineEdit.dynamicAction = dynamicAction;

});